import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-[14.08px] text-sm font-normal ring-offset-background transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0f3e17] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-[#0f3e17] text-[#fffefc] hover:bg-[#0c2f10]",
        destructive:
          "bg-[#0c2f10] text-[#fffefc] hover:bg-[#0f3e17]",
        outline:
          "bg-[#fffefc] text-[#0f3e17] hover:bg-[#e1f4df]",
        secondary:
          "bg-[#e1f4df] text-[#0f3e17] hover:bg-[#cfe7d3]",
        ghost: "hover:bg-[#e1f4df] hover:text-[#0f3e17]",
        link: "text-[#0f3e17] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-[21px] py-[14px]",
        sm: "h-9 px-3 rounded-[14.08px]",
        lg: "h-11 px-8 rounded-[14.08px]",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, ...props }, ref) => {
  return (
    <button
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
